import styles from './RatingTable.module.css';
import { SeasonLink as Link } from "../Seasons/SeasonLink";
import goldMedal from '../../assets/icons/first.svg';
import silverMedal from '../../assets/icons/second.svg';
import bronzeMedal from '../../assets/icons/third.svg';
import sfu from '../../assets/icons/sfu.svg';

function RatingTable({ type, data }) {
  const getPlaceIcon = (index) => {
    if (index === 0) return <img src={goldMedal} alt="1" className={styles.medal} />;
    if (index === 1) return <img src={silverMedal} alt="2" className={styles.medal} />;
    if (index === 2) return <img src={bronzeMedal} alt="3" className={styles.medal} />;
    return <div className={styles.placeNumber}>{index + 1}</div>;
  };

  if (type === 'members') {
    return (
      <table className={styles.table}>
        <thead>
          <tr className={styles.headerRow}>
            <th className={styles.nameColumn}>ФИО</th>
            <th className={styles.teamColumn}>Команда</th>
            <th style={{ textAlign: 'left' }} className={styles.balanceColumn}>Рейтинг</th>
          </tr>
        </thead>
        <tbody>
          {data.map((member, index) => (
            <tr key={member.id} className={styles.row}>
              <td className={styles.nameCell}>
                <div className={styles.nameWithPlace}>
                  {getPlaceIcon((member.rank || index + 1) - 1)}
                  <span>
                    {member.name}
                    {member.login ? ` (@${member.login})` : ''}
                    {member.pendingAccount && <small style={{ display: 'block' }}>Ожидает привязки аккаунта</small>}
                  </span>
                </div>
              </td>
              <td className={styles.teamCell}>{member.team}</td>
              <td className={styles.balanceCell}><img src={sfu} alt="" /> {member.ratingScore ?? member.balance}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  return (
    <table className={styles.table}>
      <thead>
        <tr className={styles.headerRow}>
          <th className={styles.teamNameColumn}>Название команды</th>
          <th className={styles.membersColumn}>Аватар / Капитан</th>
          <th className={styles.balanceColumn}>Рейтинг</th>
        </tr>
      </thead>
      <tbody>
        {data.map((team, index) => (
          <tr key={team.id} className={styles.row}>
            <td className={styles.teamNameCell}>
              <div className={styles.nameWithPlace}>
                {getPlaceIcon((team.rank || index + 1) - 1)}
                <Link className={styles.teamLink} to={`/search/teams/${team.id}?q=${encodeURIComponent(team.teamName || '')}`}>
                  {team.teamName}
                </Link>
              </div>
            </td>
            <td className={styles.membersCell}>
              <div className={styles.members}>
                <img
                  src={team.avatar}
                  alt={team.teamName}
                  className={styles.avatar}
                />
                <span className={styles.captainText}>{team.captainLogin || '-'}</span>
              </div>
            </td>
            <td className={styles.balanceCell}>
              <div className={styles.ratingValue}>
                <span><img src={sfu} alt="" /> {team.ratingScore ?? team.balance}</span>
                <small>Баланс: {team.balance}</small>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default RatingTable;
